module.exports = __webpack_public_path__ + "static/media/moldova-small.37c44214.jpg";